import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../globals/common_utilities/axios_old";
import CONSTANTS from "../../globals/common_utilities/constant";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API, STATUS, ROLE, APP_ROUTES } from "../../globals/constants/index";

const initialState = {
  loading: false,
  Response: [],
  error: "",
};

export const Redux_calender_list = createAsyncThunk(
  "calender_data/Redux_calender_list",
  ({ token, body }) => {
    console.log("payload", token);
    return api_call(
      "POST",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.CALENDER
      }`,
      {},
      {},
      body
    );
  }
);

const calender_data = createSlice({
  name: "calender_data",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(Redux_calender_list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(Redux_calender_list.fulfilled, (state, action) => {
      state.loading = false;
      state.Response = action.payload;
      state.error = "";
    });
    builder.addCase(Redux_calender_list.rejected, (state, action) => {
      state.loading = false;
      state.Response = [];
      state.error = action.error.message;
    });
  },
});

export const Redux_calender_selected_training = createAsyncThunk(
  "calender_selected_training/Redux_calender_selected_training",
  ({ token, params }) => {
    console.log("params------------------->>>", params);
    return api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.CALENDERID
      }`,
      params,
      {}
    );
  }
);
//'https://e6ajh3xbob.execute-api.ap-south-1.amazonaws.com/dev/api/v1/training/dates'
const calender_selected_training = createSlice({
  name: "calender_selected_training",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(Redux_calender_selected_training.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      Redux_calender_selected_training.fulfilled,
      (state, action) => {
        state.loading = false;
        state.Response = action.payload;
        state.error = "";
      }
    );
    builder.addCase(
      Redux_calender_selected_training.rejected,
      (state, action) => {
        state.loading = false;
        state.Response = [];
        state.error = action.error.message;
      }
    );
  },
});

export const Redux_selected_training_selected_student_data = createAsyncThunk(
  "selected_training_student_data/Redux_selected_training_selected_student_data",
  ({ token, params }) => {
    let selectedResponse = api_call(
      "GET",
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.GET_STUDENT_TRAINING_LISTING
      }`,
      { is_intrested: "Default" },
      {}
    );
    //"https://e6ajh3xbob.execute-api.ap-south-1.amazonaws.com/dev/api/v1/training/student?is_intrested=Default",

    let acceptedResponse = api_call(
      CONSTANTS.API_METHODS.GET,
      `${
        CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
        API.END_POINTS.GET_STUDENT_TRAINING_LISTING
      }`,
      { is_intrested: "Accepted" },
      {}
    );
    // "https://e6ajh3xbob.execute-api.ap-south-1.amazonaws.com/dev/api/v1/training/student?is_intrested=Accepted",
    return {
      selectedResponse,
      acceptedResponse,
    };
  }
);

const selected_training_student_data = createSlice({
  name: "selected_training_student_data",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(
      Redux_selected_training_selected_student_data.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      Redux_selected_training_selected_student_data.fulfilled,
      (state, action) => {
        state.loading = false;
        state.Response = action.payload;
        state.error = "";
      }
    );
    builder.addCase(
      Redux_selected_training_selected_student_data.rejected,
      (state, action) => {
        state.loading = false;
        state.Response = [];
        state.error = action.error.message;
      }
    );
  },
});

// export const Redux_primary_aws = createAsyncThunk('primary_aws/Redux_primary_aws', ({token}) => {
// 	console.log('payload', token);
// 	return api_call(
//         CONSTANTS.API_METHODS.GET,
//         'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/region',
//         {},
//       {},
//       );
// });

// const primary_aws = createSlice({
// 	name: 'primary_aws',
// 	initialState,
// 	extraReducers: (builder) => {
// 		builder.addCase(Redux_primary_aws.pending, (state) => {
// 			state.loading = true;
// 		});
// 		builder.addCase(Redux_primary_aws.fulfilled, (state, action) => {
// 			state.loading = false;
// 			state.Response = action.payload;
// 			state.error = '';
// 		});
// 		builder.addCase(Redux_primary_aws.rejected, (state, action) => {
// 			state.loading = false;
// 			state.Response = [];
// 			state.error = action.error.message;
// 		});
// 	},
// });

// export const Redux_add_training_center = createAsyncThunk('add_training_center/Redux_add_training_center', ({token,body}) => {
// 	console.log('payload', token);
// 	return api_call(
//         CONSTANTS.API_METHODS.POST,
//         'https://cta472fzih.execute-api.ap-south-1.amazonaws.com/dev/api/v1/studios',
//         {},
//       {},
// 	  body
//       );
// });

// const add_training_center = createSlice({
// 	name: 'add_training_center',
// 	initialState,
// 	extraReducers: (builder) => {
// 		builder.addCase(Redux_add_training_center.pending, (state) => {
// 			state.loading = true;
// 		});
// 		builder.addCase(Redux_add_training_center.fulfilled, (state, action) => {
// 			state.loading = false;
// 			state.Response = action.payload;
// 			state.error = '';
// 		});
// 		builder.addCase(Redux_add_training_center.rejected, (state, action) => {
// 			state.loading = false;
// 			state.Response = [];
// 			state.error = action.error.message;
// 		});
// 	},
// });

export const veyon_reducer = {
  // location_list: location_list.reducer,
  calender_data: calender_data.reducer,
  calender_selected_training: calender_selected_training.reducer,
  selected_training_student_data: selected_training_student_data.reducer,
  // primary_aws:primary_aws.reducer,
  // add_training_center:add_training_center.reducer
};
